<script lang="ts">
    import type {ExternalLoanLoanability} from 'src/typings';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let capability: ExternalLoanLoanability;
</script>

<a href={capability.url} target="_blank">
    <IconedContent trailingIcon="link" justify="start">
        <slot/>
    </IconedContent>
</a>